import React from 'react';
import PropTypes from 'prop-types';
import RadioButton from './RadioButton';
import InteractionOutcomeIndicator from '../../interactionOutcome/InteractionOutcomeIndicator';
import styles from './matchInteraction.scss';

const AlternativeCell = (props) => {
    const {
        columnChoiceIdentifier,
        correctResponses,
        handleUserResponse,
        isInverted,
        isReadOnly,
        isSelected,
        modelIdentifier,
        rowChoiceIdentifier,
        questionId,
    } = props;

    const showAnswers = correctResponses !== undefined;
    const classList = [styles.radioButtonWrapper];

    if (isSelected) {
        classList.push(styles.checked);
    }
    if (showAnswers) {
        classList.push(styles.checkAnswers);
    }

    return (
        <td className={classList.join(' ')}>
            <RadioButton
                checked={isSelected}
                columnChoiceIdentifier={columnChoiceIdentifier}
                handleUserResponse={handleUserResponse}
                isInverted={isInverted}
                isReadOnly={isReadOnly}
                modelIdentifier={modelIdentifier}
                rowChoiceIdentifier={rowChoiceIdentifier}
                questionId={questionId}
            />

            { showAnswers &&
                <InteractionOutcomeIndicator
                    answerOption={`${rowChoiceIdentifier} ${columnChoiceIdentifier}`}
                    correctResponses={correctResponses}
                    isAttempted={isSelected}
                    skipUnansweredIndicator
                />
            }
        </td>
    );
};

AlternativeCell.propTypes = {
    columnChoiceIdentifier: PropTypes.string.isRequired,
    correctResponses: PropTypes.array,
    handleUserResponse: PropTypes.func.isRequired,
    isInverted: PropTypes.bool.isRequired,
    isReadOnly: PropTypes.bool,
    isSelected: PropTypes.bool.isRequired,
    modelIdentifier: PropTypes.string.isRequired,
    rowChoiceIdentifier: PropTypes.string.isRequired,
    questionId: PropTypes.number.isRequired,
};

export default AlternativeCell;
